import React, {useState} from 'react';
import {Container, Collapse, Row, Col, Tabs, Tab, Table, Card, Form} from 'react-bootstrap';
import '../layout/main.scss';
import '../home/home.scss';
import './mywallet.scss';
import qrcode from '../../images/qrcode.png';
import {faAngleDown} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import troycard from "../../images/TROYGRUN.jpg";


function MyWallet() {
    const [open, setOpen] = useState(false);

    return (
        <div className="App">
            <div className="my-wallet">
                <Container>
                    <h3>My Wallet</h3>
                    <div className="wallet-info">
                        <img src={qrcode} alt="qrcode"/>
                        <p>0x4d9lergTg...EADkenTH5tgw5G</p>

                        <div className="casa-info">
                            <h5
                                onClick={() => setOpen(!open)}
                                aria-controls="casalist"
                                aria-expanded={open}>
                                Casa Addresses <FontAwesomeIcon icon={faAngleDown}/></h5>
                            <Collapse in={open}>
                                <div id="casalist">
                                    <hr/>
                                    <p>Counterparty</p>
                                    <p>Ethereum</p>
                                    <p>Klaytn</p>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                    <div className="wallet-content">
                        <Tabs defaultActiveKey="Orbs" id="orbs-tab" className="mb-3">
                            <Tab eventKey="Orbs" title="Orbs">
                                <div className="wallet_filters">Filters
                                    <Form.Select aria-label="SelectCollection">
                                        <option>Collection</option>
                                        <option value="1">Spells of Genesis</option>
                                        <option value="2">Crypto Kitties</option>
                                        <option value="3">Blah blah</option>
                                    </Form.Select>
                                    <Form.Select aria-label="SelectChain">
                                        <option>Blockchain</option>
                                        <option value="1">Bitcoin/Counterparty</option>
                                        <option value="2">Ethereum</option>
                                        <option value="3">Klaytn</option>
                                        <option value="4">Kusama</option>
                                    </Form.Select>
                                </div>
                                <div className="mn-blocks home-asset">
                                    <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                                        {Array.from({ length: 8 }).map((_, idx) => (
                                            <Col>
                                                <Card className="cards cardAsset">
                                                    <Card.Img variant="top" src={troycard} />
                                                    <Card.Body>
                                                        <h5>TROYGRUN</h5>
                                                        <h6>Spells of genesis</h6>
                                                        <hr/>
                                                        <div className="clearfix">
                                                            <span style={{float: 'left'}}>Issuance date:</span>
                                                            <span style={{float: 'right'}}>06.03.2016</span>
                                                        </div>
                                                        <div className="clearfix">
                                                            <span style={{float: 'left'}}>Nb issued:</span>
                                                            <span style={{float: 'right'}}>300</span>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </Tab>
                            <Tab eventKey="Transactions" title="Transactions">
                                <Table striped bordered hover>
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Asset/Contract</th>
                                        <th>Image</th>
                                        <th>Time</th>
                                        <th>Blockchain</th>
                                        <th>Collection</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>Qty</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>TROYGRUN</td>
                                        <td>(image)</td>
                                        <td>Timestamp</td>
                                        <td>Counterparty</td>
                                        <td>Spells of Genesis</td>
                                        <td>1jnewfr...sd46z</td>
                                        <td>1lfn84r...48fnh</td>
                                        <td>1</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>TROYGRUN</td>
                                        <td>(image)</td>
                                        <td>Timestamp</td>
                                        <td>Counterparty</td>
                                        <td>Spells of Genesis</td>
                                        <td>1jnewfr...sd46z</td>
                                        <td>1lfn84r...48fnh</td>
                                        <td>1</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>TROYGRUN</td>
                                        <td>(image)</td>
                                        <td>Timestamp</td>
                                        <td>Counterparty</td>
                                        <td>Spells of Genesis</td>
                                        <td>1jnewfr...sd46z</td>
                                        <td>1lfn84r...48fnh</td>
                                        <td>1</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </Tab>
                            <Tab eventKey="Info" title="Info">
                                Wallet info stuff
                            </Tab>
                        </Tabs>
                    </div>

                </Container>
            </div>
        </div>
    );
}

export default MyWallet;
